import React from 'react';
import ReactDOM from 'react-dom';
import MarketStore from '../../stores/MarketStore';
import MarketActions from '../../actions/MarketActions';
import _ from 'underscore';
import cx from 'react-classset';
import AuthStore from '../../stores/AuthenticationStore';
import clone from 'clone';
import SubHeader from '../Inventory/InventorySubHeader.react';
import Item from '../Inventory/Item.react';

var Market = React.createClass({
    getInitialState: function() {
      return {
        openMarketId: null,
        marketItems: [],
      };
    },
    componentDidMount: function() {
      MarketActions.getAllItems();
      MarketStore.listen(this.onChange);
    },
    componentWillUnmount: function() {
      MarketStore.unlisten(this.onChange);
    },
    onChange: function() {
      var MarketState = MarketStore.getState();
      this.setState(MarketState);
    },
    toggleOpen: function(key){
      const open = this.state.openMarketId === key;
      const id = open ? null : key;
      this.setState({ openMarketId: id });
    },
    mapEquipment: function(result, key) {
      const equipment = clone(result);
      return(
        <Item
          id={key}
          key={key}
          toggleOpen={this.toggleOpen.bind(this, key)}
          equipment={equipment}
          open={
            (this.state.openMarketId === key) ? true : false
          }
          isHidden={false}
          isMarket={true}
          openDelete={() => console.log('delete')}
          openEdit={() => console.log('edit')}
          openAdd={() => console.log('add')}
          quanity={1}
          group={[]}
        />
      );
    },
    updateFilter: function(newFilter) {
      this.setState({ filter: newFilter });
    },
    render: function() {
        return (
          <div className="content_section">
            <SubHeader isMarket={true} updateFilter={this.updateFilter} />
            <div id="equipmentList" className="top-margin">
              <div className="equipment-list-container">
                <div className="equipment-list-item-wrapper title" >
                  <div className="equipment-list-item" >
                    <div className="eq eq-status"></div>
                    <div className="eq eq-brand">Vörumerki</div>
                    <div className="eq eq-title">Vara</div>
                    <div className="eq eq-type">Tegund</div>
                    <div className="eq eq-loc">Staðsetning</div>
                    <div className="eq eq-date">Skráningardagur</div>
                    <div className="eq eq-price">Verð</div>
                  </div>
                </div>
                {_.map(this.state.filteredMarketItems, this.mapEquipment)}
              </div>
            </div>
          </div>
        );
    }
});

module.exports = Market;



// WEBPACK FOOTER //
// ./app/scripts/ui/Market/Market.react.js